module.exports = __webpack_public_path__ + "img/software-thumb-3-mod.ec146ef8.png";